
// 配置线下本地开发测试参数：
//  let mServerRootPath = "http://192.168.1.171:8888/bnvs";   //本地Java类   http://192.168.1.171:8888/bnvs
//  let mainPath = "http://192.168.1.171";                    //本地Net页面
// //  //let mServerRootPath = "http://127.0.0.1:8080/bnvs";
//  let routerPath = "http://192.168.1.171:8888/teacherPC/#"



// 线上服务器说明
//1、百年职校线上服务器，先前只有点Net端，公网映射IP地址143，其中143的5005端口部署了测试文件，143的80端口部署了正式文件
//2、从职校第4期开始，线上增加了Tomcat端，使用143的8080端口部署了测试文件；同时，启用新的131服务器（新的独立主机），使用131的80端口部署了正式文件
//3、注意：143的测试Tomcat、131的正式Tomcat中，部署了四个Vue端，其中“学生APP端”线下编译好的名称是"studentAPP"，但部署到143或者131时，名称要改成"mobile"

// 配置线上测试服务器参数 
// let mServerRootPath = "http://oa.bnvs.cn:8080/bnvs";   //测试服务器 Tomcat端的8080端口，公网映射IP地址143 （访问测试的java类）
// // //let modelUrl = "http://oa.bnvs.cn:8080";    //测试服务器 Tomcat端的8080端口，公网映射IP地址143 （访问测试的java类）
// let mainPath = "http://oa.bnvs.cn:5005";    //测试服务器 Net端的5005端口，公网映射IP地址143  （访问测试的Net页面）
// let routerPath = "http://oa.bnvs.cn:8080/teacherPC/#" // 测试服务器，跳转访问的后台页面

// 配置线上正式服务器参数
let mServerRootPath = "http://stu.bnvs.cn/bnvs";   //正式服务器 Tomcat端的80端口，公网映射IP地址131 （访问正式的java类）  http://119.254.227.131/bnvs
// let modelUrl = "http://stu.bnvs.cn/bnvs";    //正式服务器 Tomcat端的80端口，公网映射IP地址131 （访问正式的java类）   http://119.254.227.131/bnvs
let mainPath = "http://oa.bnvs.cn/bnvs";    //正式服务器 Net端的80端口，公网映射IP地址143  （访问正式的Net页面）    http://119.254.227.143/bnvs
let routerPath = "http://stu.bnvs.cn/teacherPC/#" // 测试服务器，跳转访问的后台页面

let mRestfulApiPath = "aras";
let maxDate=3 //学生提交选课计划最大周数
let mIsDerive=false;
let Auther=null;
export default {
    getModelUrl: function () {
        return modelUrl
    },
    getMaxDate: function () {
        return maxDate;
    },
    setMaxDate: function (maxDateData){
        maxDate=maxDateData;
    },
    //获得后台服务器路径
    getMainPath: function () {
        return mainPath
    },
    //获得后台服务器路径,跳转后台页面用
    getRouterPath: function () {
        return routerPath
    },
    //获得API服务器路径
    getApiServerPath: function () {
        return mServerRootPath + "/" + mRestfulApiPath;
    },

    //获得文件服务器路径
    getFilesServerPath: function (url) {
        return mServerRootPath + "/" + url;
    },

    //判断是否是设备，true为设备，false为浏览器
    isDerive:function(){
        return mIsDerive;
    },
    setIsDerive:function(value){
        mIsDerive=value;
    },
    //Auther对象
    getAuther:function(){
        return Auther;
    },
    setAuther:function(msg){
        Auther=msg;
    }
}



// WEBPACK FOOTER //
// ./src/config.js